import {Component, HostBinding, Input} from "@angular/core";

@Component({
    selector: 'logo-marianne',
    template: `<ng-content></ng-content>`,
    standalone: true,
    styleUrls: ['./logo-marianne.component.scss']
})
export class LogoMarianneComponent {
    @HostBinding('class.logo-marianne') logoMarianne = true;
    @HostBinding('class.logo-marianne__footer') @Input() isFooter = false;
    @HostBinding('class.logo-marianne__popin') @Input() isInPopIn = false;
}
